module.exports = __webpack_public_path__ + "static/media/credit-card-blank.524358be.svg";